import Request from './request';
import consts from "@/consts.js";

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-material-positions/get-material-list-by-position", data);
}

export default {
    fetchAll,
};